import { extendObservable, runInAction } from 'mobx';

import { FinancingController } from '../../../networking/controllers/FinancingController';
import { ProductsController } from '../../../networking/controllers/ProductsController';
import { Logger } from '../../../helpers/Logger';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';

class ProductStoreClass {
  constructor() {
    extendObservable(this, {
      product: null,
      financingWithInitialPayment: null,
      error: false,
    });
  }

  async fetchProduct(id) {
    try {
      runInAction(() => {
        this.error = false;
        if (this.product && this.product.id !== id) {
          this.product = null;
        }
      });
      const product = await ProductsController.find(id);
      const productPrice = ConfigParametersStore.isValueInFeatureFlagData('product-price', id);
      if (!product.shouldShowPrice() && productPrice) {
        product.financing = productPrice;
      }
      runInAction(() => {
        this.product = product;
        this.financingWithInitialPayment = product.financing.withInitialPayment;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.error = true;
      });
    }
  }

  async fetchFinancingForProduct(amount) {
    if (!this.product) {
      Logger.warn('Attempted to fetch financing for a non existent product');
      return;
    }
    runInAction(() => {
      this.financingWithInitialPayment = null;
    });
    try {
      const prodFinancing = await FinancingController.find(this.product.id, amount);
      runInAction(() => {
        this.financingWithInitialPayment = prodFinancing.withInitialPayment;
      });
    } catch (error) {
      Logger.warn(error);
    }
  }

  clearError() {
    runInAction(() => {
      this.error = false;
    });
  }
}

export const ProductStore = new ProductStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-detail/stores/ProductStore.js